module.exports = new __parcel__URL__("map-marker-selected.90cac6ea.svg").toString();